import * as React from 'react';
import { useSelector } from 'react-redux';

import { banksListSelector } from '../../../../selectors';
import { selectMortgageRates } from '../../../../selectors/mortgage/rates';
import { MortgageFrame } from '../../../offer_gallery/createMortgageFrame';

export const MortgageSlide = () => {
  const banksList = useSelector(banksListSelector);
  const rates = useSelector(selectMortgageRates);

  return <MortgageFrame banksList={banksList} rates={rates} />;
};
